import { render, staticRenderFns } from "./AboutAffiant.vue?vue&type=template&id=2492742d"
import script from "./AboutAffiant.vue?vue&type=script&lang=ts"
export * from "./AboutAffiant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports